module.exports = "<div class=\"controls-nav-container\">\r\n    <ul class=\"nav controls-nav navbar-inner\">\r\n    </ul>\r\n\r\n    <div class=\"advanced-search-closer\" role=\"button\" aria-label=\"Close advanced search\">\r\n        <i class=\"fa fa-remove\" aria-hidden=\"true\"></i>\r\n    </div>\r\n</div>\r\n<div class=\"forms-region\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/advanced-search/advanced-search-forms.html
// module id = 400
// module chunks = 1